import { type ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title: string;
  children?: ReactNode;
};

export const FullPageMessage = ({ icon, title, children }: Props) => (
  <main className="flex min-h-screen items-center justify-center bg-paper px-4">
    <div className="w-full max-w-sm rounded-xl border border-line bg-white p-8 text-center shadow-sm">
      <div className="mx-auto mb-4 flex size-10 items-center justify-center rounded-full bg-paper text-ink">
        {icon}
      </div>
      <h1 className="font-serif text-xl text-ink">{title}</h1>
      {children && <div className="mt-2 space-y-4 text-sm text-muted">{children}</div>}
    </div>
  </main>
);
